import { AxiosResponse } from "axios";
import { TSchedule } from "../shared/types/schedule.type";
import axiosInstance from "./base";
import { GallopDataType } from "../shared/types/gallopData.type";

export class GallopData {

    static getGalopReviewData(options: string[]):Promise<AxiosResponse<GallopDataType>> {
        return axiosInstance.get('gallop-review-data?'.concat(options.join('&')))
    }

    static getGallops(userId?: string): Promise<AxiosResponse<TSchedule[]>> {
        return axiosInstance.get(`send_gallop_review_configurations?user=${userId}`)
    }

    static saveConfig(data: Partial<TSchedule>): Promise<AxiosResponse<TSchedule>> {
        return axiosInstance.post('send_gallop_review_configurations', data)
    }
    static updateConfig(id: number, config: Partial<TSchedule>): Promise<AxiosResponse<TSchedule>> {
        return axiosInstance.patch(`send_gallop_review_configurations/${id}`, config, {
            headers: {
                'Content-Type': 'application/merge-patch+json',
            }
        })
    }
    static deleteConfig(id: number) {
        return axiosInstance.delete(`send_gallop_review_configurations/${id}`)
    }

    static generatePhrase(data: Partial<TSchedule>): Promise<AxiosResponse<TSchedule>> {
        return axiosInstance.post('send_gallop_review/preview', data)
    }
}